import { api as dataEnteringApi } from "../api";

interface CreateActivityParams {
    accountingDocumentId?: string;
    accountingDocumentType?: string;
    accountId: number;
    documentId: number;
    type: string;
    startedAt: number;
    finishedAt: number;
}

interface CreateActivityResponse {
    id: number;
}

export const activityApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        createActivity: build.mutation<CreateActivityResponse, CreateActivityParams>({
            query: (body) => ({
                url: "api/v1/data_entering/activities",
                method: "POST",
                body,
            }),
        }),
    }),
});
